import Landing from "./src/pages/landing";
import SearchView from "./src/pages/search-view"
import SearchViewProgress from "./src/pages/search-progress"

export const LandingPage = Landing;
export const SearchViewPage = SearchView;
export const SearchProgressViewPage = SearchViewProgress;
